import { render, staticRenderFns } from "./stations.vue?vue&type=template&id=636fa712&scoped=true"
import script from "./stations.vue?vue&type=script&lang=js"
export * from "./stations.vue?vue&type=script&lang=js"
import style0 from "./stations.vue?vue&type=style&index=0&id=636fa712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636fa712",
  null
  
)

export default component.exports